// In your component that needs to load saved data

/* eslint-disable react/no-array-index-key */
import React, { useContext } from 'react';
import { useLoadSavedHCPCS } from '@mummssoftware/common-ui';
import {
  GlobalContext,
  HCPCSGlobalContext,
  SET_HCPCS_CHOICE,
  SET_HCPCS_DURATION,
  ADD_SAVED_ICD_CODE,
  SET_ICD_SECTION,
} from '@mummssoftware/global-context';
import { HCPCSSelection } from './HCPCSSelection';
import { demoans } from './answers1';

interface HCPCSAnswer {
  hcpcsCode: string;
  hcpcsDiagnoses: string[];
  rate: number;
  modifier: string | null;
  facilityId: number;
  facilityType: string;
}

export const EditHCPCS = () => {
  const { dispatchHCPCS } = useContext(HCPCSGlobalContext);
  const { editingPastVisit } = useContext(GlobalContext);
  const hcpcsData = (editingPastVisit as any)?.physicianServices;

  const hcpcsMenu = window.env?.hcpcs?.doctor || [];
  // This will automatically populate the form with saved data
  // todo change
  useLoadSavedHCPCS(
    hcpcsData as any,
    dispatchHCPCS,
    hcpcsMenu,
    SET_HCPCS_CHOICE,
    SET_HCPCS_DURATION,
    SET_ICD_SECTION,
    ADD_SAVED_ICD_CODE,
  );

  return <HCPCSSelection></HCPCSSelection>;
};
